//--------------Color Name--------
$(document).ready(function () {
  $(".option_names.Color input").on("click", function () {
    var selectedColor = $(this).val();

    // Hide the default text
    $(this)
      // .parents(".product-form__input")
      // .siblings(".variant__label")
      // .find(".curr_val")
      // .hide();

    // Update the variant title with the selected color
    $(this)
      .parents(".product-form__input")
      // .siblings(".variant__label")
      .find(".opt_title")
      .html(selectedColor);
  });
  
});



//-----------------image-zoom-----
// let $ = jQuery.noConflict();

// $(document).ready(function () {
//   $("#imageZoom").dblclick(function(){
//   alert("The paragraph was double-clicked");
//   });
// 	// Image zoom plugin code
// 	let zoomImage = $("#imageZoom");
// 	let zoomImageExtra = $("#imageZoomExtra");
// 	let zoomImagePlus = $("#imageZoomExtraPlus");
// 	zoomImage.imageZoom();
// 	zoomImageExtra.imageZoom({ zoom: 200 });
// 	zoomImagePlus.imageZoom({ zoom: 300 });
// });